import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,[_c('authorized',[_c('ampifire-header')],1),_c(VMain,{key:_vm.cacheKey,staticClass:"main-background"},[_c('system-messages',{staticClass:"py-0"}),_c('keep-alive',{attrs:{"include":_vm.alive}},[_vm._t("default")],2),_c('toast-notification')],1),_c('cookie-consent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }